<!--
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="feed-cont">
    <div v-show="!loadMaskShow">
      <!-- 头部区域 -->
      <div class="header">
        <div class="header-l">
          <div>
            <div class="back" @click="goBack">
              <van-icon name="arrow-left" />
            </div>
            <span @click="trueDateBox">{{ date }}</span>
            <img
              :class="dateBoxFlag ? 'arrow_top' : ''"
              src="@/assets/images/home/arrows1.png"
              alt=""
            />
            <!-- <i :class="dateBoxFlag ? 'arrow_top' : 'arrow_down'"></i> -->
          </div>

        </div>
        <div>一共喂养{{ countNumber }}次</div>
        <!-- <div>喂养间隔：{{ feedInterval }}</div> -->
      </div>

      <!-- 日历区域 -->
      <div class="date-box" v-show="dateBoxFlag">
        <div class="day-select">
          <div>
            <button @click="reduceYear">
              <van-icon name="arrow-left" /><van-icon
                name="arrow-left"
                class="reduceYear-icon"
              />
            </button>
            <button @click="reduceMonth"><van-icon name="arrow-left" /></button>
          </div>
          <div>
            <span>{{ year }}</span
            >年<span>{{ month }}月</span>
          </div>
          <div>
            <button @click="addMonth">
              <van-icon name="arrow" />
            </button>
            <button @click="addYear">
              <van-icon name="arrow" class="reduceYear-icon-r" />
              <van-icon name="arrow" />
            </button>
          </div>
        </div>
        <div class="day-screen">
          <div>
            <span v-for="item in week" :key="item">{{ item }}</span>
          </div>
          <div @click="selectDay">
            <span
              v-for="day in previousMonth"
              :key="day + 50"
              class="previousMonth"
            >
              {{ day }}
            </span>
            <!-- {{monthDay[month - 1]}} -->
            <span
              class="currentMonth"
              v-for="(item, index) in monthData"
              :key="item.value"
              :class="[
                isActive(index),
                IstodayIndex && index + 1 > todayIndex ? 'isDisable' : ''
              ]"
            >
              {{ item.value }}
              <i v-if="item.isRecord"></i>
            </span>
            <span
              v-for="item1 in nextMonth"
              :key="item1 + 100"
              class="nextMonth"
              >{{ item1 }}</span
            >
          </div>
        </div>
        <div class="gray-line"></div>
      </div>

      <!-- 列表区域 -->
      <feed-list
        ref="list"
        :feedDate="searchResultParams.feedDate"
        :feedType="feedType"
        @handleData="initHeatData"
        :sourceFrom="'feedNode'"
      >
      </feed-list>

      <div class="zhanwei"></div>

      <div class="addBtn" @click="goAddRecord">
        <div class="add">添加记录</div>
      </div>
      <!-- <div class="addBtn" @click="goAddRecord">
        <van-icon name="add-o" />
        添加记录
      </div> -->
    </div>

    <!-- 固定返回按钮 -->
    <goBack @goBack="goBack"></goBack>
    <!-- 加载中 -->
    <!-- <load-mask v-show="loadMaskShow"></load-mask> -->
  </div>
</template>

<script>
import { shareHome } from '@/minxs/shareHome.js';
import { Exposurer_feedToolsAllpageView } from '@/assets/js/Exposure';
import FeedAPI from '@/utils/axiosApi/feedApi';
import loadMask from '@/components/common/loading.vue'; //加载弹窗
import feedList from '@/views/contents/tools/feedRecord/components/feedList.vue'; //列表组件
import goBack from '@/components/common/goBack.vue'; //返回组件

export default {
  name: 'feedNode',
  mixins: [shareHome],
  components: {
    feedList,
    loadMask,
    goBack
  },
  data() {
    return {
      countNumber: '', // 喂养多少次
      feedInterval: '', // 喂养间隔
      dateBoxFlag: false, // 日历是否展开
      year: 0, // 年
      month: 0, // 月
      day: 0, // 日
      previousMonth: [], // 日历上个月展示几天
      nextMonth: [], // 日历下个月展示几天
      week: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'], //星期几列表
      monthDay: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], //每个月最后日期
      monthData: [], //当月日期
      isSameDay: false, //是否是一个月里面的天数

      searchResultParams: {
        feedDate: ''
      }, //分页
      loadMaskShow: true, //loading动画
      UserInfo: null, //用户信息
      feedType: this.$route.query.feedType, //首页是奶粉喂养还是母乳喂养
      today: '', //今天时间
      IstodayIndex: true, //是否在当月
      todayIndex: null, //今下标
      isCurrent: false //当前月份中是否有高亮的天
    };
  },
  computed: {
    // 查看年月日变化
    date() {
      if (this.year == 0 || this.month == 0 || this.day == 0) {
        return '';
      }
      let month = this.month;
      let day = this.day;
      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;

      //处理切换月份到当前月  选中的时间不能大于今天
      var lastDay = new Date(this.year, this.month, 0).getDate();
      if (day > lastDay){
         day = lastDay;
         this.day = lastDay;
      }


      const year = this.year;
      const month1 = month;
      const yearParam = this.today.split('-')[0];
      const monthParam = this.today.split('-')[1];
      const day1 = this.today.split('-')[2];
      if (yearParam == year && month1 == monthParam  && day > day1) {
        day = day1;
        this.day = day1;
      }
      

      this.searchResultParams.feedDate = this.year + '-' + month + '-' + day;
      if (!this.isSameDay) {
        // this.loadMaskShow = true;
        this.getRecord();
      }
      return this.year + '年' + this.month + '月' + day + '日';
    }
  },
  watch: {
    year: function(val) {
      let reg = /^[1-9]\d*$/g;
      if (!reg.test(val)) {
        let date = new Date();
        this.year = date.getFullYear();
      }
      if (val < 0) {
        this.year = 1;
      }
      if (val > 10000) {
        this.year = 10000;
      }
      this.dayScreen();
    },
    month: function(val) {
      let reg = /^[1-9]\d*$/g;
      if (!reg.test(val)) {
        let date = new Date();
        this.month = date.getMonth() + 1;
      }
      if (val < 1) {
        this.month = 1;
      }
      if (val > 12) {
        this.month = 12;
      }
      this.dayScreen();
    }
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.$store.commit('changeIncludes', ['feedNode']); //设置缓存
    this.getInitDate();
  },
  mounted() {
    this.$refs.list.getFeedList();
    //浏览页面埋点
    setTimeout(() => {
      const data = JSON.parse(localStorage.getItem('toolFeedPoint'));
      Exposurer_feedToolsAllpageView.observe('.feed-cont', false, {
        System_FeedingCapacity: data.System_FeedingCapacity,
        Baby_Month: data.Baby_Month,
        Feeding_way_Home: data.Feeding_way_Home,
        page_name: '喂养日记首页'
      });
    }, 2000);
  },
  activated() {
    if (this.searchResultParams.feedDate != this.today) {
      this.getRecord();
    }
    this.$refs.list.searchResultList = [];
    this.$refs.list.getFeedList();
  },

  methods: {
    // 获取当前日志
    getInitDate() {
      var mydate = new Date();
      var month = mydate.getMonth() + 1;
      var day = mydate.getDate();
      var year = mydate.getFullYear();
      this.month = month;
      this.day = day;
      this.year = year;
      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      this.today = year + '-' + month + '-' + day;
    },
    // 赋值喂养次数和时间间隔
    initHeatData(data) {
      this.countNumber = data.countNumber;
      this.feedInterval = data.feedInterval;
    },
    // 获取日历当月喂养记录
    getRecord() {
      const len = this.monthDay[this.month - 1]; //这个月有多少天

      FeedAPI.getWhetherFeed(
        {},
        {
          crmId: this.UserInfo.crm_id,
          feedDate: this.searchResultParams.feedDate,
          parity: this.$route.query.num || 1
        },
        (res) => {
          if (res.code == 200) {
            const data = res.data;
            this.monthData = [];
            //格式化时间记录
            let arr = []; //接口返回有记录天
            for (let index = 0; index < data.length; index++) {
              var s = new Date(data[index]);
              arr.push(s.getDate());
            }
            //添加到时间日历里面
            const yearParam = this.searchResultParams.feedDate.split('-')[0];
            const year = this.today.split('-')[0];
            const monthParam = this.searchResultParams.feedDate.split('-')[1];
            const month = this.today.split('-')[1];
            const day = this.today.split('-')[2];
            if (yearParam == year && month == monthParam) {
              this.IstodayIndex = true;
            } else {
              this.IstodayIndex = false;
            }

            for (let index1 = 1; index1 <= len; index1++) {
              if (arr.indexOf(index1) > -1) {
                this._hanleMonth(yearParam, year, month, monthParam, day, index1, true);
              } else {
                this._hanleMonth(yearParam, year, month, monthParam, day, index1, false);
              }
            }

            this.loadMaskShow = false;
          }
        },
        (res) => {
          this.loadMaskShow = false;
        }
      );
    },
    _hanleMonth(yearParam, year, month, monthParam, day, index1, isRecord) {
      if (yearParam == year && month == monthParam && day == index1) {
        this.todayIndex = index1;
        this.monthData.push({ isRecord: isRecord, value: '今' });
      } else {
        this.monthData.push({ isRecord: isRecord, value: index1 });
      }
    },
    // 突出显示当前日期
    isActive(index) {
      if (index + 1 == this.day) {
        return {
          active: true
        };
      }
    },
    // 显示日期盒子并初始化
    trueDateBox() {
      if (this.date === '') {
        let date = new Date();
        this.year = date.getFullYear();
        if (this.isLeapYear(this.year)) {
          this.monthDay[1] = 29;
        } else {
          this.monthDay[1] = 28;
        }
        this.month = date.getMonth() + 1;
        this.day = date.getDate();
      }
      this.dateBoxFlag = !this.dateBoxFlag;
    },
    // 增减年份
    addYear() {
      var mydate = new Date();
      var month = mydate.getMonth() + 1;
      var year = mydate.getFullYear();

      if (this.year + 1 > year) {
        this._toast('不能查看未来的日期哦');
        return;
      } else {
        this.year++;
        if (this.year === year) {
          this.month = month;
        }
        this._runYearDay();
      }
      this.isSameDay = false;
    },
    reduceYear() {
      const year = this.today.split('-')[0];
      if (parseInt(year) - 10 == this.year) {
        this._toast('只能添加近10年的记录哦');
        return;
      } else {
        this.year--;
        this._runYearDay();
        this.isSameDay = false;
      }
    },
    // 增减月份
    addMonth() {
      var mydate = new Date();
      var month = mydate.getMonth() + 1;
      var year = mydate.getFullYear();

      if (this.year + 1 > year && this.month + 1 > month) {
        this._toast('不能查看未来的日期哦');
        return;
      } else {
        this.month++;
        if (this.month > 12) {
          this.month = 1;
          this.year++;
        }
      }
      this.isSameDay = false;
    },
    reduceMonth() {
      this.month--;
      if (this.month < 1) {
        const year = this.today.split('-')[0];
        if (parseInt(year) - 10 == this.year) {
          this._toast('只能添加近10年的记录哦');
          return;
        } else {
          this.month = 12;
          this.year--;
        }
      }
      this.isSameDay = false;
    },
    // 选择日期
    selectDay(e) {
      var mydate = new Date();
      var month = mydate.getMonth() + 1;
      var day = mydate.getDate();
      var year = mydate.getFullYear();

      let targetClass = e.target.className;
      if (targetClass == 'previousMonth') {
        if (this.month == 1) {
          this.month = 12;
          this.year--;
        } else {
          this.month = this.month - 1;
        }
        this.isSameDay = false;
        this.day = parseInt(e.target.innerText);
      } else if (targetClass == 'nextMonth') {
        if (this.month == 12) {
          if (this.year + 1 > year) {
            this._toast('不能查看未来的日期哦');
            return;
          } else {
            this.month = 1;
            this.year++;
          }
        } else {
          if (this.month + 1 > month) {
            this._toast('不能查看未来的日期哦');
            return;
          } else {
            this.month = this.month + 1;
          }
        }

        this.isSameDay = false;
        this.day = parseInt(e.target.innerText);
      } else if (targetClass == 'currentMonth') {
        if (
          this.year + 1 > year &&
          this.month + 1 > month &&
          e.target.innerText > day
        ) {
          this._toast('不能查看未来的日期哦');
          return;
        } else {
          this.isSameDay = true;
          if (e.target.innerText == '今') {
            this.day = parseInt(this.today.split('-')[2]);
          } else {
            this.day = e.target.innerText;
          }
        }
      }
    },
    _runYearDay() {
      if (this.isLeapYear(this.year)) {
        this.monthDay[1] = 29;
      } else {
        this.monthDay[1] = 28;
      }
    },
    _toast(text) {
      this.$toast({
        message: text,
        duration: 1000
      });
    },
    // 处理上个月和下个月日期显示
    dayScreen() {
      // 上一个月
      let firstDate = new Date(this.year, this.month - 1, 1);
      let firstWeek = firstDate.getDay();
      let preMonthDay = null;
      if (this.month == 1) {
        preMonthDay = this.monthDay[11];
      } else {
        preMonthDay = this.monthDay[this.month - 2];
      }
      for (let i = 0; i < preMonthDay; i++) {
        this.previousMonth[i] = i + 1;
      }
      if (firstWeek == 0) {
        this.previousMonth = this.previousMonth.slice(-7);
      } else {
        this.previousMonth = this.previousMonth.slice(-firstWeek);
      }
      // 下一个月
      let endDate = new Date(
        this.year,
        this.month - 1,
        this.monthDay[this.month - 1]
      );
      let endWeek = endDate.getDay();
      let nextMonthDay = null;
      if (this.month == 12) {
        nextMonthDay = this.monthDay[0];
      } else {
        nextMonthDay = this.monthDay[this.month];
      }
      for (let i = 0; i < nextMonthDay; i++) {
        this.nextMonth[i] = i + 1;
      }
      if (endWeek == 6) {
        this.nextMonth = this.nextMonth.slice(0, 7);
      } else {
        this.nextMonth = this.nextMonth.slice(0, 6 - endWeek);
      }
    },
    // 判断是否是闰年
    isLeapYear(year) {
      return year % 100 == 0
        ? year % 400 == 0
          ? true
          : false
        : year % 4 == 0
        ? true
        : false;
    },
    // 添加记录按钮跳转
    goAddRecord() {
      const date = this.year + '/' + this.month + '/' + this.day;
      this.$router.push({
        path: '/addFeed',
        query: {
          type: 1,
          monthAge: this.$route.query.monthAge,
          num: this.$route.query.num,
          feedType: this.$route.query.feedType,
          date: date,
          source: 'feedNode'
        }
      });
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less">
body {
  background: #f2f2f2;
}
</style>
<style lang="less" scoped>
.loading_box {
  background: rgba(0, 0, 0, 0.6);
}
.feed-cont {
  overflow: hidden;
  background: #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
}

.zhanwei {
  width: 100%;
  height: 78px;
  background: #f2f2f2;
}

.addBtn {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 68px;
  background: #fff;
  padding-top: 10px;
  box-shadow: 0px 0px 8px -1px rgba(238, 238, 238, 1);//rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  .add {
    width: 339px;
    height: 44px;
    background: #FB6E7E;
    border-radius: 22px;
    margin: 0 auto;
    font-size: 18px;
    text-align: center;
    color: #fff;
    line-height: 44px;
  }
}

// .addBtn {
//   margin: 20px 13px 86px;
//   width: 350px;
//   height: 40px;
//   border-radius: 4px;
//   border: 1px dashed #000000;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 14px;
//   color: #333333;
//   .van-icon-add-o {
//     margin-right: 2px;
//   }
// }
.reduceYear-icon {
  left: -7px;
}
.reduceYear-icon-r {
  left: 7px;
}
.header {
  padding: 15px 12px 12px 13px;
  font-size: 12px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .back {
    width: 10px;
    height: 20px;
    position: relative;
    margin-right: 10px;
    .van-icon-arrow-left {
      position: absolute;
      left: -5px;
      color: #1a1a1a;
      font-size: 20px;
    }
  }
  .arrow_top {
    transform: rotate(180deg);
  }
  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-l {
    > div:first-child {
      display: flex;
      align-items: center;
    }
    // > div:last-child {
    //   margin-left: 15px;
    // }
    span {
      margin-left: 79px;
      font-size: 18px;
      color: #333333;
    }
    img {
      margin-left: 4px;
      width: 9px;
    }
  }
}
.fs10 {
  transform: scale(0.85);
  font-size: 12px;
  display: inline-block;
}

/deep/ .van-list__finished-text,
/deep/ .van-list__loading {
  background: #ffffff;
}

.feed-list {
  margin: 10px 0px;
  overflow: hidden;
}

.date-pickers {
  display: inline-block;
  position: relative;
  > input {
    width: 50%;
    height: 20px;
    padding: 5px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
  transform: translateY(-10px);
}
.date-box {
  // margin: 0 11px 34px 13px;
  // box-shadow: 0px 3px 10px 0px rgba(200, 201, 204, 0.5);
  border-radius: 3px;
  background: #ffffff;
  padding: 20px 15px 14px 15px;
  box-sizing: border-box;
  div.day-select {
    display: flex;
    height: 30px;
    line-height: 30px;
    color: #323233;

    input,
    button {
      border: none;
      background: white;
      text-align: center;
      font-weight: 500;
      color: #969799;
      font-size: 22px;
    }
    button {
      padding: 1px 6px;
      font-weight: 600;
    }
    i {
      font-size: 12px;
      color: #969799;
      font-weight: bold;
      top: 1px;
    }
    > div:nth-child(1),
    > div:nth-child(3) {
      width: 20%;
    }
    > div:nth-child(2) {
      font-size: 16px;
      width: 60%;
      display: flex;
      justify-content: center;
      padding-top: 2px;
      input:hover {
        background: #eee;
      }
      input:nth-child(1) {
        width: 50px;
      }
      input:nth-child(2) {
        width: 30px;
      }
    }
  }
  div.day-screen {
    > div {
      width: 100%;
      // padding: 0 5px;
      display: flex;
      // font-size: 18px;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 7px 0;
      > span,
      .currentMonth {
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        margin-top: 13px;
        margin-right: 7.5px;
        margin-left: 7.5px;
        // border-bottom: 1px solid #ccc;
      }
      .currentMonth {
        position: relative;
        i {
          position: absolute;
          border-radius: 50%;
          bottom: -9px;
          left: 50%;
          width: 6px;
          height: 6px;
          // background: #999999;
          background: #FF7181;
          margin-left: -3px;
        }
      }
      .active {
        background: #FF7181;
        // background: #ffb915;
        border-radius: 50%;

        color: #ffffff !important;
      }
    }
    > div:nth-child(1) {
      justify-content: space-between;

      color: #939496;
      // font-weight: bold;
      // background: #f8f8f8;
    }
    > div:nth-child(2) {
      span {
        cursor: pointer;
        color: #323233;
        // &:hover,
        // &.active {
        //   background: #21a5ef;
        //   color: white;
        // }
      }
      span.previousMonth,
      span.nextMonth {
        color: #c8c9cc;
      }
      span.isDisable {
        color: #c8c9cc;
      }
    }
  }
  div.gray-line {
    width: 100%;
    height: 1px;
    background: #EEEEEE;
  }
}
</style>
